export type TabKey = 'status' | 'chat' | 'native' | 'yuzu' | 'kohaku'

interface TabBarProps { active: TabKey; onChange: (tab: TabKey) => void }
interface TabDef { key: TabKey; label: string; aria: string; kind: 'svg' | 'emoji'; emoji?: string; svgPath?: string }

const TABS: TabDef[] = [
  { key: 'status', label: '状态', aria: '状态', kind: 'svg', svgPath: 'M4.5 10.5 3.5 4l4.2 2.6a8.5 8.5 0 0 1 8.6 0L20.5 4l-1 6.5a8.5 8.5 0 1 1-15 0z' },
  { key: 'chat', label: '聊天', aria: '聊天', kind: 'svg', svgPath: 'M21 11.5a8 8 0 0 1-8.5 8H4l1.6-3.2A8 8 0 1 1 21 11.5z' },
  { key: 'native', label: 'Native', aria: 'Native Chat', kind: 'emoji', emoji: '🧪' },
  { key: 'yuzu', label: '柚子猫', aria: '柚子猫', kind: 'emoji', emoji: '🐱' },
  { key: 'kohaku', label: '琥珀', aria: '琥珀', kind: 'emoji', emoji: '🧡' },
]

export function TabBar({ active, onChange }: TabBarProps) {
  return <div className="tab-bar">{TABS.map((t) => <button key={t.key} type="button" className={`tab-item ${active === t.key ? 'active' : ''}`} onClick={() => onChange(t.key)} aria-label={t.aria}>
    {t.kind === 'svg' ? <svg className="tab-icon" viewBox="0 0 24 24"><path d={t.svgPath} />{t.key === 'status' && <><circle cx="9" cy="12.5" r="0.4" /><circle cx="15" cy="12.5" r="0.4" /></>}</svg> : <span className="tab-icon-emoji" style={{ fontSize: 20, lineHeight: 1.1 }}>{t.emoji}</span>}
    <span className="tab-label">{t.label}</span><div className="tab-dot" />
  </button>)}</div>
}
